import colors from 'tailwindcss/colors';

export default [
  colors.emerald['400'],
  colors.yellow['400'],
  colors.red['400'],
  colors.blue['400'],
  colors.purple['400']
];
